import { Option as OptionModel } from "../models/option";

type Props = {
    option: OptionModel;
    isSelected: boolean;
    setOption: (option: OptionModel) => void;
}

export const Option = ({ option, isSelected, setOption }: Props) => {

    const onClick = () => {
        setOption(option);
    }

    const isCorrect = isSelected && option.correct;
    const isIncorrect = isSelected && !option.correct;
    const style = isCorrect ? 'correct' : isIncorrect ? 'incorrect' : '';
    
    return (
        <div className="option">
            <div className={`title ${style}`} onClick={onClick}>
                <strong>{option.id}. </strong>
                {option.title}
            </div>
        </div>
    );
};